import * as React from 'react';
import { FeatherIcon } from './FeatherIcon';

interface ChecklistItemProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  children: React.ReactNode;
}

export const ChecklistItem = ({
  children,
  checked,
  ...checkboxProps
}: ChecklistItemProps) => {
  return (
    <label className="flex justify-between items-center hover:bg-grey-100 cursor-pointer transition px-4 py-2 rounded-lg">
      <div
        className={`flex w-full items-center ${checked ? '' : 'text-grey-500'}`}
      >
        {children}
      </div>
      {checked ? (
        <FeatherIcon icon={'check'} className="text-theme2 flex-shrink-0" />
      ) : null}
      <input
        {...checkboxProps}
        type="checkbox"
        checked={checked}
        className="hidden"
      />
    </label>
  );
};
